import React from "react";

const HelpSupport : React.FC = () => {
    return(
        <>
            Help Support
        </>
    )
}

export default HelpSupport